// Import optimized versions of the logo
import logoWebp from '../assets/images/optimized/logo.webp';
import logoAvif from '../assets/images/optimized/logo.avif';
import logoPng from '../assets/images/optimized/logo.png';

// Use separate constant for dimensions to ensure consistency
const LOGO_WIDTH = 85;
const LOGO_HEIGHT = 25; // Adjust if needed


function Header() {
  return (
    <div
      className="flex justify-between h-[66px] items-center px-[50px] bg-[white]"
      style={{
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.10)',
      }}>
      <div className="relative">
        <picture>
          {/* AVIF format for best compression (Chrome, Firefox) */}
          <source srcSet={logoAvif} type="image/avif" />
          {/* WebP for broader support (most modern browsers) */}
          <source srcSet={logoWebp} type="image/webp" />
          {/* PNG fallback for universal support */}
          <img 
            src={logoPng}
            alt="Health Deal logo" 
            className="w-[85px] relative z-10"
            width={LOGO_WIDTH}
            height={LOGO_HEIGHT}
            fetchPriority="high"
            decoding="async"
          />
        </picture>
      </div>
      <a href="tel:1300369399" className="flex items-center gap-[8px] no-underline">
        <div className="flex items-center justify-center w-[36px] h-[36px] rounded-full bg-[#F0F2F5]">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#17385D" stroke="none">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </div>
        <span className="text-[black] text-[14px] font-medium">1300 369 399</span>
      </a>
    </div>
  );
}

export default Header;
